import React from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";

const downloadLoader = css`
  display: block;
  margin: 10px 15px 0;
  float: right;
`;

function Radiobox({
  singleExport,
  multipleExport,
  onChange,
  label,
  loaderStatus,
  setExportValue,
  exportValue,
}) {
  return (
    <div className="radiobox-container">
      <div
        className="flex-box"
        onClick={() => onChange(!singleExport && !multipleExport)}
      >
        <div className="export-content">
          <div
            className={`indicator ${singleExport ? "checked" : ""} ${
              multipleExport ? "checked" : ""
            }`}
          ></div>
        </div>
        <div className="model-label">{label}</div>
      </div>
      {(multipleExport || singleExport) && (
        <>
          <div>
            <input
              type="text"
              className="export-input"
              value={exportValue}
              placeholder={singleExport ? "Job ID" : "Plan Name"}
              onChange={(evt) => {
                setExportValue(evt.target.value);
              }}
            />
          </div>
          {loaderStatus && (
            <ClipLoader
              css={downloadLoader}
              size={15}
              color={"#4183C5"}
              loading={true}
            />
          )}
        </>
      )}
    </div>
  );
}

export default Radiobox;
